import { render, staticRenderFns } from "./TransferStatusBadge.vue?vue&type=template&id=7e178381"
import script from "./TransferStatusBadge.vue?vue&type=script&lang=js"
export * from "./TransferStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports